import { get } from './request'


export const getOTACodes = (codeType: string, subCat: string) => get(`/searchOTACode?codeType=${codeType}&subCat=${subCat}`)
